// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__19mYW","imageUploader":"EGiftCard_imageUploader__3eKQx"};